import { Controller } from '@hotwired/stimulus'

// Both segments of an extended entry light up together, so hovering either
// one reads as hovering the single entry they draw.
export default class extends Controller {
  static values = { key: String }

  on() {
    this.halves.forEach(half => half.setAttribute('data-hovered', ''))
  }

  off() {
    this.halves.forEach(half => half.removeAttribute('data-hovered'))
  }

  get halves() {
    return document.querySelectorAll(`[data-calendar--extended-hover-key-value="${this.keyValue}"]`)
  }
}
